<template>
  <footer id="footer">
    <!-- Footer Top -->
    <div class="footer_top">
      <div class="inr">
        <div class="area_addr">
          <div class="logo">대구광역시</div>
          <p class="address">
            <span>동인청사 : (우 41911) 대구광역시 중구 공평로 88</span>
            <span>산격청사 : (우 41542) 대구광역시 북구 연암로 40 / 전화번호 : 053)120</span>
            <span><strong>대구시청</strong> | 사업자등록번호 : 501-83-00016 | 대표자 : 추경호</span>

          </p>
        </div>
        <div class="right">
          <p class="tel">
            <span class="txt">강좌정보, 신청, 결제, 환불 등은 <br>	각 해당 교육기관으로 문의</span>
          </p>
        </div>
      </div>
    </div>
    <!-- // Footer Top -->
    <!-- Footer bottom -->
    <div class="footer_btm">
      <div class="inr">
        <ul class="f_menu">
          <li class="privacy"><a href="http://www.daegu.go.kr/index.do?menu_id=00050250" target="_blank" title="새창열림">개인정보처리방침</a>
          </li>
          <li><RouterLink to="/cms/00008">이용약관</RouterLink></li>
          <li><a href="https://www.daegu.go.kr/index.do?menu_id=00050251" target="_blank" title="새창열림">저작권정책</a></li>
        </ul>
        <div class="copy">Copyright(C) 2021 Daegu Metropolitan City. All rights reserved</div>
      </div>
      <!-- // Footer bottom -->
    </div>
  </footer>
</template>
<script setup>
  defineOptions({ name: "Footer" });
</script>
